module.exports = __webpack_public_path__ + "static/media/banner.4a5b3cf5.jpg";